import React, { useState, useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

const Header: React.FC = () => {
  const [mobileNavActive, setMobileNavActive] = useState(false);
  const [helpDropdownOpen, setHelpDropdownOpen] = useState(false);

  // Toggle mobile nav
  const toggleMobileNav = () => setMobileNavActive(prev => !prev);

  // Close mobile nav when a link is clicked
  const handleLinkClick = () => {
    if (mobileNavActive) setMobileNavActive(false);
    setHelpDropdownOpen(false);
  };

  // Toggle Help Center dropdown
  const toggleHelpDropdown = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault(); // prevent jump
    setHelpDropdownOpen(prev => !prev);
  };

  // Add/remove body class for mobile nav
  useEffect(() => {
    const body = document.body;
    if (mobileNavActive) body.classList.add("mobile-nav-active");
    else body.classList.remove("mobile-nav-active");

    return () => body.classList.remove("mobile-nav-active");
  }, [mobileNavActive]);

  return (
    <header className="header d-flex align-items-center fixed-top">
      <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
        <a href="/" className="logo d-flex align-items-center">
          <h1 className="sitename modern-logo">SailorsData</h1>
        </a>

        <nav className={`navmenu ${mobileNavActive ? "mobile-nav-active" : ""}`}>
          <ul>
            <li>
              <a href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=post-a-job`} onClick={handleLinkClick}>
                <i className="bi bi-briefcase-fill"></i> Post a Job
              </a>
            </li>

            <li>
              <a href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=upload-cv`} onClick={handleLinkClick}>
                <i className="bi bi-upload"></i> Upload CV
              </a>
            </li>

            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                <i className="bi bi-journal-text"></i>  Resources
              </a>
            </li>

            <li className="dropdown">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="toggle-dropdown" onClick={toggleHelpDropdown}>
                <i className="bi bi-life-preserver"></i>  Help Center <i className={`bi bi-chevron-${helpDropdownOpen ? "up" : "down"}`}></i>
              </a>
              {helpDropdownOpen && (
                <ul className="dropdown-menu dropdown-active">
                  <li><a href="/contact" onClick={handleLinkClick}><i className="bi bi-geo-alt"></i> Locate</a></li>
                  <li>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <i className="bi bi-chat-dots"></i> Chat
                    </a>
                  </li>
                  <li>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <i className="bi bi-telephone"></i> Call
                    </a>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <a href="/latest-jobs" onClick={handleLinkClick}><i className="bi bi-search"></i> Find Jobs</a>
            </li>

            <li>
              <a href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=portal-login`} onClick={handleLinkClick}>
                <i className="bi bi-arrow-right-square-fill"></i>
              </a>
            </li>
          </ul>

          <i className={`mobile-nav-toggle d-xl-none bi ${mobileNavActive ? "bi-x" : "bi-list"}`} onClick={toggleMobileNav}></i>

        </nav>
      </div>
    </header>
  );
};

export default Header;
